import useDownloadCSV from "hooks/useDownloadCSV";
import useFilterHook from "hooks/useFilter";
import usePagination from "hooks/usePagination";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  ADD_OBSERVATION_COLUMN_DATA,
  DOCUMENT_COLUMNS_DATA,
  COLUMN_DATA,
  FILTER_DEFINITIONS,
} from "./config";
import {
  downloadCSV,
  fetchData,
  fetchDownloadAllowed,
  fetchDownloadInvestigationDocument,
  fetchGeneratePDF,
  fetchObservationResultEntryData,
  fetchReportPDfDownload,
  fetchViewObservationResultEntryData,
  multipleGeneratePDF,
  updateStatus,
} from "services/resultEntryReportMaster";
import { DEFAULT_TOTAL_RECORDS, MODALS, STALE_TIME } from "utils/constants";
import Table from "components/Common/Table/resultEntryindex";
import "./PatientLabSearchReport.scss";
import {
  getDoctorList,
  getFranchiseTypesList,
  getInvestigationList,
  getZoneList,
  getDepartmentList,
  getStatusList,
  getPackageList,
  getFranchiseList,
  getLabDepartmentList,
} from "../../../redux/action/drop_list_action";
import { useDispatch, useSelector } from "react-redux";
import Modal from "components/Common/Modal";
import ObservationInformation from "./ObservationInfo";
import UploadDocument from "./UploadDocument";
import AddObservationValue from "./AddObservationValue";
import Loader from "components/Common/loader";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import useDownloadPDF from "hooks/useDownloadPDF";
import Swal from "sweetalert2";
import { resetResultEntryObservations } from "../../../redux/action/result_entry_observation_action";
import zoneLocalStorageId from "utils/zone";
import {
  createSampleCollectRejectionReason,
  fetchSampleCollectionInResultEntry,
} from "services/sampleCollection";
import RejectionReasonDropDown from "components/Common/Dropdowns/RejectionReasonDropDown";
import { useAlert } from "context/alert";
import SampleInformation from "pages/SampleCollection/sampleInformation";
import useSingleDownloadPDF from "hooks/useSingleDownloadPDF";
import { fetchAllocateZoneById } from "services/allocateZone";
import companyLocalStorageId from "utils/companyID";
import ApprovedModalInsideRow from "./ApprovedModalInsideRow";
import CommonFilter from "./Commonfilter";
import useRefetchByIds from "../../../hooks/useRefetchByIds";

const PannelWiseBusinessReport = () => {
  const { showAlert } = useAlert();
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const location = useLocation();

  const pendingIdsRef = useRef([]);

  const [rowDataForObservation, setRowDataForObservation] = useState(null);
  const [isObservationOpenDetails, setIsObservationOpenDetails] =
    useState(false);
  const [rowDataForObservationDetails, setRowDataForObservationDetails] =
    useState(null);
  const [rowDataInvestigationDocument, setRowDataInvestigationDocument] =
    useState(null);
  const [rowDataForPatientDetails, setRowDataForPatientDetails] =
    useState(null);
  const dispatch = useDispatch();
  const [documentModal, setDocumentModal] = useState(false);
  const [documentInfo, setdocumentInfo] = useState();
  const [openedFrom, setOpenedFrom] = useState(null);
  const [state, setState] = useState([]);
  const [isOpenObservationValue, setIsOpenObservationValue] = useState(false);
  const [isOpenApproved, setIsOpenApproved] = useState(false);
  const [isOpenSampleCollection, setIsOpenSampleCollection] = useState(false);
  const [isSampleCollectionRowData, setSampleCollectionRowData] =
    useState(null);
  const [isSampleCollectAppointmentId, setSampleCollectAppointmentId] =
    useState(null);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [requiredFeild, setRequiredFeild] = useState(false);
  const [tempone, setTempone] = useState([]);
  const [temp, setTemp] = useState([]);
  const [orgtemp, setorgtemp] = useState();
  const [selectedRejection, setSelectedRejection] = useState(null);
  const [openDownloadPdfData, setOpenDownloadPdfData] = useState(null);
  const [generateButtonData, setgenerateButtonData] = useState(null);
  const [selectedFranchiseId, setSelectedFranchiseId] = useState(null);

  const fIsSuperFranchise = Number(localStorage.getItem("is_super_franchise"));
  const fIsFranchiseEmployee = Number(
    localStorage.getItem("is_franchise_employee"),
  );
  const subFranchise = Number(localStorage.getItem("sub_franchise"));
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowsData, setSelectedRowsData] = useState([]);
  const [editableRows, setEditableRows] = useState({});
  const [currentRowData, setCurrentRowData] = useState(null);
  const contentRef = useRef();
  const [withFooterChecked, setWithFooterChecked] = useState(false);
  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
  const _token =
    jwtAuthreducer?.token_values?.sub &&
    JSON.parse(jwtAuthreducer?.token_values?.sub?.replace(/'/g, '"'));

  const auth = useSelector((state) => state.jwtAuthreducer);

  const [expandedRowId, setExpandedRowId] = useState(null);

  const [totalTests, setTotalTests] = useState(0);
  const [totalPatients, setTotalPatients] = useState(0);

  const [status, setStatus] = useState("");

  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const formattedToday = yyyy + "-" + mm + "-" + dd;

  today.setDate(today.getDate() - 1);
  let yesterdayDd = today.getDate();
  let yesterdayMm = today.getMonth() + 1;
  const yesterdayYyyy = today.getFullYear();

  if (yesterdayDd < 10) yesterdayDd = "0" + yesterdayDd;
  if (yesterdayMm < 10) yesterdayMm = "0" + yesterdayMm;

  const formattedYesterday =
    yesterdayYyyy + "-" + yesterdayMm + "-" + yesterdayDd;

  const INITIAL_SEARCH_STATE = {
    uhid_no: "",
    slide_no: "",
    gender: "",
    zone_id: "",
    patient_name: "",
    barcode_no: "",
    appointment_id: "",
    package_id: "",
    search_by_date: "",
    mobile_no: "",
    card_no: "",
    refered_by: "",
    app_status: "",
    investigation_id: "",
    franchise_id: "",
    lab_department_id: "",
    is_urgent: false,
    from_date: formattedToday,
    to_date: formattedToday,
    registration_no: "",
  };

  const [searchValue, setSearchValue] = useState(INITIAL_SEARCH_STATE);

  const handleInputChange = (key, value) => {
    setSearchValue((prev) => ({ ...prev, [key]: value }));
  };

  const { mutate: downloadSinglePDF } = useSingleDownloadPDF(fetchGeneratePDF);
  const { mutate: downloadMultiplePDF } = useDownloadPDF(multipleGeneratePDF);

  const {
    investigation_list,
    zone_list,
    package_list,
    franchise_list,
    lab_department_list,
  } = useSelector((state) => state.dropListReducer);

  const [selectedZone, setSelectedZone] = useState(null);
  useEffect(() => {
    const storedZoneId = localStorage.getItem("zone_id");
    if (storedZoneId) {
      const matchedZone = zone_list?.zone_data?.find(
        (item) => item.zone_id === Number(storedZoneId),
      );
      if (matchedZone) {
        setSelectedZone({
          value: matchedZone.zone_id,
          label: matchedZone.zone_name || matchedZone.zone_obj?.zone_name || "",
        });
      }
    }
  }, [zone_list]);

  const {
    currentPage,
    itemPerPage,
    disablePrev,
    disableNext,
    disableFirst,
    disableLast,
    totalPages,
    updateCurrentPage,
    updateTotalRecords,
  } = usePagination();

  const DownloadButton = useDownloadCSV(downloadCSV, "Result_entry_report.csv");
  const queryClient = useQueryClient();
  const { filters, updateFilter, updateMultipleFilters } = useFilterHook(
    FILTER_DEFINITIONS,
    updateCurrentPage,
  );

  const BUSINESS_REPORT_QUERY_KEY = ["fetch-bussiness-report", currentPage];

  const { refetchByIds, isRefetchingByIds } = useRefetchByIds(
    BUSINESS_REPORT_QUERY_KEY,
  );

  const handleSearch = useCallback(() => {
    const hasAppointmentOrBarcode =
      searchValue.appointment_id || searchValue.barcode_no;

    updateFilter("app_status", "");

    Object.entries(searchValue).forEach(([name, value]) => {
      if (name === "app_status") return;
      if (
        hasAppointmentOrBarcode &&
        (name === "from_date" || name === "to_date")
      ) {
        updateFilter(name, "");
        return;
      }
      updateFilter(name, value);
    });

    setSelectedRows([]);
    setSelectedRowsData([]);
    setEditableRows({});
  }, [searchValue, updateFilter]);

  useEffect(() => {
    const handleGlobalEnter = (e) => {
      if (e.key === "Enter") handleSearch();
    };
    if (location.pathname === "/patient-wise-search-report") {
      window.addEventListener("keydown", handleGlobalEnter);
    }
    return () => window.removeEventListener("keydown", handleGlobalEnter);
  }, [location.pathname, handleSearch]);

  const handleCheckboxChange = (event) => {
    const isChecked = event.target.checked;
    setSearchValue((prev) => ({ ...prev, is_urgent: isChecked }));
    updateFilter("is_urgent", isChecked);
  };

  const { data: ZoneDropDownData, isLoading: isLoadingZone } = useQuery(
    ["fetch-zone-by-id", auth?.user?.employee_code_id],
    () =>
      fetchAllocateZoneById({ employee_code_id: auth?.user?.employee_code_id }),
    {
      staleTime: STALE_TIME,
      enabled: !!auth?.user?.employee_code_id,
    },
  );

  const options =
    ZoneDropDownData?.data?.map((option) => ({
      value: option?.zone_id,
      label: option?.zone_obj?.zone_name,
    })) || [];

  const {
    data: bussinessReportData,
    isFetching,
    refetch: refetchBussinessReport,
  } = useQuery(
    BUSINESS_REPORT_QUERY_KEY,
    () => fetchData(currentPage, filters),
    {
      enabled: false,
      keepPreviousData: false,
      staleTime: STALE_TIME,
      onSuccess: (res) => {
        updateTotalRecords(res?.data?.additional_data?.total_count);
        setTotalPatients(res?.data?.additional_data?.total_patient_count);
        setTotalTests(res?.data?.additional_data?.investigation_count);
      },
      select: (res) => {
        const response = res?.data?.data;
        if (response?.length) {
          res.data.data = response.map((x, index) => ({
            ...x,
            _index: (currentPage - 1) * DEFAULT_TOTAL_RECORDS + index + 1,
          }));
        }
        return res;
      },
      onError: (res) => console.error("Error fetching Report Entry:", res),
    },
  );

  const {
    data: viewObservationData,
    isLoading: isLoadingViewObservation,
    refetch: refetchViewObservation,
  } = useQuery(
    [
      "fetch-view-observation-result-entry",
      rowDataForObservationDetails?.appointment_id,
      rowDataForObservationDetails?.investigation_data?.investigation_id,
    ],
    () =>
      fetchViewObservationResultEntryData({
        registartion_id: rowDataForObservationDetails?.appointment_id,
        investigation_id:
          rowDataForObservationDetails?.investigation_data?.investigation_id,
      }),
    {
      staleTime: STALE_TIME,
      enabled: Boolean(
        rowDataForObservationDetails?.appointment_id &&
        rowDataForObservationDetails?.investigation_data?.investigation_id,
      ),
      onSuccess: () => setIsObservationOpenDetails(true),
      select: (res) => {
        const response = res?.data?.data;
        if (response?.length) {
          res.data.data = response.map((x, index) => ({
            ...x,
            _index: (currentPage - 1) * DEFAULT_TOTAL_RECORDS + index + 1,
          }));
        }
        return res;
      },
      onError: (res) => console.error("Error fetching payments:", res),
    },
  );

  const {
    data: listPayment,
    isLoading: isLoadingPayment,
    refetch: refetchPayment,
  } = useQuery(
    [
      "fetch-observation-result-entry",
      currentRowData?.appointment_id,
      currentRowData?.investigation_data?.investigation_id,
    ],
    () =>
      fetchObservationResultEntryData({
        appointment_id: currentRowData?.appointment_id,
        investigation_id: currentRowData?.investigation_data?.investigation_id,
      }),
    {
      staleTime: STALE_TIME,
      select: (res) => {
        const response = res?.data?.data;
        if (response?.length) {
          res.data.data = response.map((x) => ({ ...x }));
        }
        return res;
      },
      onError: (res) => console.error("Error fetching payments:", res),
      enabled:
        !!currentRowData?.appointment_id &&
        !!currentRowData?.investigation_data?.investigation_id,
    },
  );

  const {
    data: pdfData,
    isLoading: pdfLoading,
    refetch: refetchPdf,
  } = useQuery(
    ["fetch-pdf-download", openDownloadPdfData?.appointment_id],
    () =>
      fetchReportPDfDownload({
        appointment_id: openDownloadPdfData?.appointment_id,
      }),
    {
      keepPreviousData: false,
      staleTime: STALE_TIME,
      enabled: !!openDownloadPdfData?.appointment_id,
      onError: (res) => console.error("Error fetching areas:", res),
    },
  );

  const { data: downloadDocument } = useQuery(
    [
      "fetch-pdf-download",
      rowDataInvestigationDocument?.appointment_id,
      rowDataInvestigationDocument?.investigation_data?.investigation_id,
    ],
    () =>
      fetchDownloadInvestigationDocument({
        investigation_id:
          rowDataInvestigationDocument?.investigation_data?.investigation_id,
        appointment_id: rowDataInvestigationDocument?.appointment_id,
      }),
    {
      keepPreviousData: false,
      staleTime: STALE_TIME,
      enabled: !!rowDataInvestigationDocument?.appointment_id,
      onError: (res) => console.error("Error fetching areas:", res),
    },
  );

  const isValidFranchiseId =
    typeof selectedFranchiseId === "number" && selectedFranchiseId > 0;

  const { data: downloadAllowed, isLoading: isLoadingDownloadAllowed } =
    useQuery(
      ["fetch-download-allowed-result-entry", selectedFranchiseId],
      () => {
        if (!isValidFranchiseId) return Promise.resolve(null);
        return fetchDownloadAllowed({ franchise_id: selectedFranchiseId });
      },
      {
        enabled: isValidFranchiseId,
        staleTime: STALE_TIME,
        select: (res) => {
          if (!res) return res;
          const response = res?.data?.data;
          if (response?.length) {
            res.data.data = response.map((x, index) => ({
              ...x,
              _index: (currentPage - 1) * DEFAULT_TOTAL_RECORDS + index + 1,
            }));
          }
          return res;
        },
        onError: (err) => console.error("Error fetching payments:", err),
      },
    );

  function downloadBase64File(base64Data, fileName) {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  useEffect(() => {
    if (downloadDocument?.data) {
      downloadBase64File(downloadDocument.data, "investigation_document.pdf");
    }
  }, [downloadDocument]);

  const {
    data: sampleCollectionData,
    isLoading,
    refetch: refetchSampleCollection,
  } = useQuery(
    [
      "fetch-sample-collection-in-result-entry",
      currentPage,
      isSampleCollectAppointmentId,
    ],
    () =>
      fetchSampleCollectionInResultEntry(
        currentPage,
        isSampleCollectAppointmentId,
      ),
    {
      enabled: !!isSampleCollectAppointmentId,
      keepPreviousData: false,
      staleTime: STALE_TIME,
      onSuccess: (res) => updateTotalRecords(res?.data?.length),
      select: (res) => {
        const response = res?.data;
        if (response?.length) {
          return {
            ...res,
            data: response.map((x, index) => ({
              ...x,
              _index: (currentPage - 1) * DEFAULT_TOTAL_RECORDS + index + 1,
            })),
          };
        }
        return res;
      },
      onError: (res) => console.error("Error fetching sample collection:", res),
    },
  );

  useEffect(() => {
    if (sampleCollectionData?.data) {
      setSampleCollectionRowData(sampleCollectionData?.data);
    }
  }, [sampleCollectionData]);

  useEffect(() => {
    if (
      Array.isArray(isSampleCollectionRowData) &&
      isSampleCollectionRowData.length > 0
    ) {
      const newState = isSampleCollectionRowData
        .filter(
          (sample) =>
            sample.investigation_data &&
            Array.isArray(sample.investigation_data),
        )
        .flatMap((sample) => sample.investigation_data)
        .filter(
          (investigation) =>
            investigation.sample_type_obj &&
            Array.isArray(investigation.sample_type_obj),
        )
        .map((investigation) => {
          const defaultSampleType = investigation.sample_type_obj.find(
            (st) => st.if_default === true,
          );
          return defaultSampleType
            ? {
                investigation_id: investigation.investigation_id,
                ifDefault: defaultSampleType.if_default,
                sample_type_id: defaultSampleType.sample_type_id,
                sample_type: defaultSampleType.sample_type,
              }
            : null;
        })
        .filter(Boolean);

      setState(newState);
    }
  }, [isSampleCollectionRowData]);

  useEffect(() => {
    if (openDownloadPdfData) refetchPdf();
  }, [openDownloadPdfData]);

  const openPdfInNewTab = (pdfData) => {
    if (pdfData) {
      const url = window.URL.createObjectURL(pdfData?.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "report.pdf");
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };

  useEffect(() => {
    if (pdfData) openPdfInNewTab(pdfData);
  }, [pdfData]);

  const onClose = useCallback(() => setDocumentModal(false), []);

  const loadNextPage = useCallback(
    () => updateCurrentPage(currentPage + 1),
    [currentPage, updateCurrentPage],
  );
  const loadPreviousPage = useCallback(
    () => updateCurrentPage(currentPage - 1),
    [currentPage, updateCurrentPage],
  );
  const loadFirstPage = useCallback(() => {
    if (currentPage !== 1) updateCurrentPage(1);
  }, [currentPage, updateCurrentPage]);
  const loadLastPage = useCallback(() => {
    if (currentPage !== totalPages) updateCurrentPage(totalPages);
  }, [currentPage, totalPages, updateCurrentPage]);

  const handleDocuments = useCallback(() => {
    setIsOpenObservationValue(false);
    setDocumentModal(true);
  }, []);

  const openObservationDetails = useCallback(
    (row) => {
      if (row) refetchViewObservation();
      setRowDataForObservationDetails(row);
    },
    [refetchViewObservation],
  );

  const downloadInvestigationDocument = useCallback(
    (row) => setRowDataInvestigationDocument(row),
    [],
  );

  const openPatientDetails = useCallback(
    (row) => {
      if (row) refetchViewObservation();
      setRowDataForPatientDetails(row);
    },
    [refetchViewObservation],
  );

  const handleCloseObservationDetails = useCallback((shouldClose) => {
    if (shouldClose) setIsObservationOpenDetails(false);
  }, []);

  const extractIds = (rows) =>
    rows
      .filter((row) => row.investigation_data?.investigation_id)
      .map((row) => ({
        appointment_id: row.appointment_id,
        investigation_id: row.investigation_data.investigation_id,
      }));

  useEffect(() => {
    const savedFilters = localStorage.getItem("patient_search_filters");
    if (savedFilters) {
      const params = new URLSearchParams(savedFilters);
      const paramsObject = Object.fromEntries(params.entries());

      const updatedValues = {
        ...paramsObject,
        is_urgent: paramsObject.is_urgent === "true",
      };

      setSearchValue((prev) => ({ ...prev, ...updatedValues }));
      updateMultipleFilters(updatedValues);
      setSelectedRows([]);
      setSelectedRowsData([]);
      setEditableRows({});

      const currentTableData = bussinessReportData?.data?.data || [];
      const savedIds = JSON.parse(localStorage.getItem("refetch_ids") || "[]");
      const ids = savedIds.length > 0 ? savedIds : extractIds(currentTableData);

      refetchByIds(ids);

      setTotalPatients(
        bussinessReportData?.data?.additional_data?.total_patient_count,
      );
      setTotalTests(
        bussinessReportData?.data?.additional_data?.investigation_count,
      );

      setTimeout(() => {
        localStorage.removeItem("patient_search_filters");
        localStorage.removeItem("refetch_ids");
      }, 500);
    } else {
      setSearchValue(INITIAL_SEARCH_STATE);
      updateCurrentPage(1);
      setSelectedRows([]);
      setSelectedRowsData([]);
      setEditableRows({});
      setCurrentRowData(null);
    }
  }, []);

  const filterRef = useRef(filters);
  useEffect(() => {
    if (filterRef.current !== filters) {
      if (!isRefetchingByIds.current) {
        refetchBussinessReport();
      }
      filterRef.current = filters;
    }
  }, [filters, refetchBussinessReport]);

  const openObservationValue = useCallback(
    (row) => {
      setIsOpenApproved(false);
      dispatch(resetResultEntryObservations());

      const mergedParams = { ...searchValue, ...filters };
      const queryParams = new URLSearchParams(mergedParams).toString();

      if (
        row?.investigation_data?.status === "APPROVED" ||
        row?.investigation_data?.status === "REPORT_ISSUED"
      ) {
        setIsOpenApproved(true);
        setRowDataForObservation(row);
      } else {
        navigate(`/observation-entry?${queryParams}`, {
          state: { rowData: row, documentInfo: documentInfo?.data },
        });
      }
    },
    [navigate, documentInfo, searchValue, filters],
  );

  const editObservationValue = useCallback(
    (row) => {
      const mergedParams = { ...searchValue, ...filters };
      const queryParams = new URLSearchParams(mergedParams).toString();
      setIsOpenApproved(false);
      navigate(`/observation-entry?${queryParams}`, {
        state: { rowData: row, documentInfo: documentInfo?.data },
      });
    },
    [navigate, documentInfo, searchValue, filters],
  );

  const handleUploadAttachmentWithObservation = useCallback(
    (row) => {
      setRowDataForObservation(row);
      setOpenedFrom("uploadAttachment");
      handleDocuments();
    },
    [handleDocuments],
  );

  const openSampleCollection = useCallback((row) => {
    setSampleCollectAppointmentId(row?.appointment_id);
    setTimeout(() => setIsOpenSampleCollection(true), 1000);
  }, []);

  const onObservationValueClose = useCallback(() => {
    dispatch(resetResultEntryObservations());
    setIsOpenObservationValue(false);
    setRowDataForObservation(null);
  }, []);

  const onApprovedClose = useCallback(() => {
    dispatch(resetResultEntryObservations());
    setIsOpenApproved(false);
    setRowDataForObservation(null);
  }, []);

  const openDownloadPdf = useCallback((row) => setOpenDownloadPdfData(row), []);

  const openDownloadPdfSuccessFully = useCallback(
    (row) => {
      const { appointment_id, investigation_data, patient_name, generated } =
        row;
      const { investigation_id } = investigation_data;

      const date = new Date(generated * 1000);
      const formattedGenerated = `${date.getDate().toString().padStart(2, "0")}-${(date.getMonth() + 1).toString().padStart(2, "0")}-${date.getFullYear()}`;
      const fileName = `${patient_name}_${formattedGenerated}`;

      const newTab = window.open("", "_blank");
      if (!newTab) {
        alert("Please allow pop-ups for this site to download the PDF.");
        return;
      }

      downloadSinglePDF(
        {
          appointment_id,
          investigation_id,
          fileName,
          display_banner: withFooterChecked,
          display_footer_banner: withFooterChecked,
           company_id: companyLocalStorageId(),
        },
        {
          onError: (error) => {
            let displayMessage = error.message;
            if (
              typeof displayMessage === "string" &&
              displayMessage.startsWith("{") &&
              displayMessage.endsWith("}")
            ) {
              try {
                const parsed = JSON.parse(displayMessage);
                displayMessage =
                  parsed.detail ||
                  parsed.message ||
                  parsed.error ||
                  displayMessage;
              } catch {
                displayMessage = error.message;
              }
            }
            newTab.close();
            Swal.fire({
              icon: "error",
              title: "Download Failed",
              text: displayMessage,
            });
          },
        },
      );
      setTimeout(() => newTab.close(), 5000);
    },
    [downloadSinglePDF, withFooterChecked],
  );

  const directDownloadPdfSuccessFully = useCallback(
    (row) => setgenerateButtonData(row),
    [],
  );

  const { mutate: addUpdateStatusMutate, isLoading: isLoadingStatus } =
    useMutation({
      mutationFn: updateStatus,
      onSuccess: (data, variables) => {
        showAlert("Successfully", "success");
        setSelectedRows([]);
        setSelectedRowsData([]);
        setStatus("");

        const ids = variables.investigation_ids.map((inv_id) => ({
          appointment_id: variables.appointment_id,
          investigation_id: inv_id,
        }));
        refetchByIds(ids);
      },
      onError: (error) => {
        showAlert(
          error?.response?.data?.message || "Something went wrong",
          "danger",
        );
      },
    });

  const handleSaveStatus = useCallback(
    (rows) => {
      if (!rows?.length) {
        Swal.fire({
          icon: "warning",
          title: "No rows selected",
          text: "Please select at least one row.",
        });
        return;
      }

      const reportIssuedRows = rows.filter(
        (row) => row.investigation_data?.status === "REPORT_ISSUED",
      );

      if (reportIssuedRows.length > 0 && status !== "NOT_APPROVED") {
        Swal.fire({
          icon: "error",
          title: "Invalid Selection",
          text: `${reportIssuedRows.length} row(s) with REPORT_ISSUED status can only be changed to NOT_APPROVED.`,
        });
        return;
      }

      const appointmentIds = [
        ...new Set(rows.map((row) => row.appointment_id)),
      ];

      if (appointmentIds.length > 1) {
        Swal.fire({
          icon: "error",
          title: "Selection Error",
          text: "Please select rows with the same Appointment ID.",
        });
        return;
      }

      if (!status) {
        Swal.fire({
          icon: "warning",
          title: "No Status Selected",
          text: "Please select a status before saving.",
        });
        return;
      }

      addUpdateStatusMutate({
        appointment_id: appointmentIds[0],
        status,
        modified_by: auth?.user?.employee_code_id || _token?.employee_id,
        investigation_ids: rows.map(
          (row) => row.investigation_data.investigation_id,
        ),
      });
    },
    [status, auth, _token, addUpdateStatusMutate],
  );

  const downloadWithButton = useCallback(
    async (validRows) => {
      if (!validRows.length) {
        Swal.fire({
          icon: "warning",
          title: "No rows selected",
          text: "Please select at least one row to proceed.",
        });
        return;
      }

      const rows = validRows.filter(
        (row) => row.investigation_data?.status !== "NOT_APPROVED",
      );

      if (!rows.length) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Selection",
          text: "PDF cannot be generated for NOT_APPROVED status.",
        });
        return;
      }

      if (rows.length < validRows.length) {
        Swal.fire({
          icon: "info",
          title: "Notice",
          text: `${validRows.length - rows.length} NOT_APPROVED row(s) will be skipped for PDF generation.`,
        });
      }

      const appointmentIds = [
        ...new Set(rows.map((row) => row.appointment_id)),
      ];
      const franchiseIds = [...new Set(rows.map((row) => row.franchise_id))];

      if (franchiseIds.length > 1) {
        Swal.fire({
          icon: "error",
          title: "Selection Error",
          text: "Different Franchise IDs detected. Please select rows with the same Franchise ID.",
        });
        return;
      }

      setSelectedFranchiseId(franchiseIds[0]);

      const permissionRes = await fetchDownloadAllowed({
        franchise_id: Number(franchiseIds[0]),
      });

      if (permissionRes?.data?.download_allowed === false) {
        Swal.fire({
          icon: "error",
          title: "Download not allowed",
          text: "Due to insufficient fund.",
        });
        return;
      }

      const refreshRows = () => refetchByIds(extractIds(rows));

      const formatDate = (timestamp) => {
        const date = new Date(timestamp * 1000);
        return `${date.getDate().toString().padStart(2, "0")}-${(
          date.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${date.getFullYear()}`;
      };

      const openLoaderTab = () => {
        const newTab = window.open("", "_blank");

        if (!newTab) {
          Swal.fire({
            icon: "error",
            title: "Pop-up Blocked",
            text: "Please allow pop-ups for this site to download the PDF.",
          });
          return null;
        }

        newTab.document.write(`
        <html>
          <head>
            <title>Downloading...</title>
            <style>
              body {
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100vh;
                font-family: Arial, sans-serif;
                flex-direction: column;
              }
              .spinner {
                margin-top: 20px;
                width: 40px;
                height: 40px;
                border: 5px solid #ccc;
                border-top: 5px solid #333;
                border-radius: 50%;
                animation: spin 1s linear infinite;
              }
              @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
              }
            </style>
          </head>
          <body>
            <h3>Downloading your file...</h3>
            <div class="spinner"></div>
          </body>
        </html>
      `);
        newTab.document.close();

        return newTab;
      };

      const handlePdfError = (error, newTab) => {
        let displayMessage = error.message;

        if (
          typeof displayMessage === "string" &&
          displayMessage.startsWith("{") &&
          displayMessage.endsWith("}")
        ) {
          try {
            const parsed = JSON.parse(displayMessage);
            displayMessage =
              parsed.detail || parsed.message || parsed.error || displayMessage;
          } catch {
            displayMessage = error.message;
          }
        }

        if (newTab) newTab.close();

        Swal.fire({
          icon: "error",
          title: "Download Failed",
          text: displayMessage,
        });
      };

      if (appointmentIds.length === 1) {
        const { appointment_id, patient_name, generated } = rows[0];

        const investigation_ids = rows.map(
          (row) => row.investigation_data.investigation_id,
        );

        const fileName = `${patient_name}_${formatDate(generated)}`;

        const newTab = openLoaderTab();
        if (!newTab) return;

        downloadSinglePDF(
          {
            appointment_id,
            investigation_id: investigation_ids,
            fileName,
            display_banner: withFooterChecked,
            display_footer_banner: withFooterChecked,
            zone_id: zoneLocalStorageId(),
            company_id: companyLocalStorageId(),
          },
          {
            onSuccess: () => {
              refreshRows();
              newTab.close();
            },
            onError: (error) => handlePdfError(error, newTab),
          },
        );
      } else {
        const appointmentData = appointmentIds.map((appointment_id) => ({
          appointment_id,
          investigation_ids: rows
            .filter((row) => row.appointment_id === appointment_id)
            .map((row) => row.investigation_data?.investigation_id || 0),
            company_id: companyLocalStorageId(),
        }));

        const uniqueNames = [
          ...new Set(rows.map((row) => row.patient_name)),
        ].join("_");

        const maxGenerated = Math.max(...rows.map((row) => row.generated));

        const fileName = `${uniqueNames}_${formatDate(maxGenerated)}.zip`;

        Swal.fire({
          icon: "info",
          title: "Downloading PDF",
          text: `Downloading PDF for: ${fileName}`,
          timer: 2000,
          showConfirmButton: false,
        });

        const newTab = openLoaderTab();
        if (!newTab) return;

        downloadMultiplePDF(
          {
            appointment_data: appointmentData,
            display_banner: withFooterChecked,
            display_footer_banner: withFooterChecked,
            fileName,
            company_id: companyLocalStorageId(),
            zone_id: zoneLocalStorageId(),
          },
          {
            onSuccess: () => {
              refreshRows();
              newTab.close();
            },
            onError: (error) => handlePdfError(error, newTab),
          },
        );
      }

      setSelectedRows([]);
      setSelectedRowsData([]);
      setEditableRows({});
    },
    [downloadSinglePDF, downloadMultiplePDF, withFooterChecked, refetchByIds],
  );

  const showGeneratePdfMultipleInvestigationIds = useCallback(
    (rows) => {
      if (!rows.length) {
        alert("No rows selected.");
        return "";
      }

      const appointment_id = rows[0].appointment_id;
      const investigationIds = rows.map(
        (row) => row.investigation_data.investigation_id,
      );
      const investigationParams = investigationIds
        .map((id) => `investigation_ids=${id}`)
        .join("&");

      return `/ResultEntryPdf?display_header=true&display_footer_banner=${withFooterChecked}&display_banner=${withFooterChecked}&display_footer=true&display_address=true&display_watermark=true&${investigationParams}&appointment_id=${appointment_id}`;
    },
    [withFooterChecked],
  );

  const handleGeneratePdfClick = () => {
    navigate(showGeneratePdfMultipleInvestigationIds(selectedRowsData) || "");
  };

  const openHtml = useCallback(() => {}, []);

  const toggleSelectAll = useCallback(
    (isChecked) => {
      if (isChecked) {
        const allRows = bussinessReportData?.data?.data || [];
        const selectableStatuses = new Set([
          "APPROVED",
          "REPORT_ISSUED",
          "NOT_APPROVED",
        ]);

        const selectableRowIndexes = allRows.reduce((acc, row, index) => {
          if (selectableStatuses.has(row.investigation_data?.status))
            acc.push(index);
          return acc;
        }, []);

        const selectableRowsData = allRows.filter((row) =>
          selectableStatuses.has(row.investigation_data?.status),
        );

        setSelectedRows(selectableRowIndexes);
        setSelectedRowsData(selectableRowsData);
        setEditableRows(
          selectableRowIndexes.reduce(
            (acc, index) => ({ ...acc, [index]: true }),
            {},
          ),
        );
      } else {
        setSelectedRows([]);
        setSelectedRowsData([]);
        setEditableRows({});
      }
    },
    [bussinessReportData],
  );

  const toggleSelectRow = useCallback((rowIndex, rowData) => {
    setSelectedRows((prev) =>
      prev.includes(rowIndex)
        ? prev.filter((id) => id !== rowIndex)
        : [...prev, rowIndex],
    );
    setSelectedRowsData((prev) => {
      const exists = prev.some((item) => item._index === rowData._index);
      return exists
        ? prev.filter((item) => item._index !== rowData._index)
        : [...prev, rowData];
    });
    setEditableRows((prev) => ({ ...prev, [rowIndex]: !prev[rowIndex] }));
  }, []);

  const [withHeaderChecked, setWithHeaderChecked] = useState(false);
  const handleHeaderChange = () => setWithHeaderChecked(!withHeaderChecked);
  const handleFooterChange = () => setWithFooterChecked(!withFooterChecked);

  const handleSelectedRejection = useCallback((selectedOption) => {
    setRequiredFeild(!selectedOption);
    setSelectedRejection(selectedOption);
  }, []);

  const handleViewModal = useCallback((row, e) => {
    setSampleCollectionRowData(row);
    setIsOpenSampleCollection(false);
    setViewModal(e);
  }, []);

  const mergedArray = useMemo(() => {
    if (
      !Array.isArray(isSampleCollectionRowData) ||
      !isSampleCollectionRowData.length
    )
      return [];

    return isSampleCollectionRowData.flatMap((sample) =>
      sample.investigation_data.map((investigation) => ({
        appointment_id: sample.appointment_id,
        generated: sample.generated,
        status: sample.status,
        barcode_no: investigation.barcode_no,
        comment: sample.comment,
        patient_name: sample.patient_name,
        patient_id: sample.patient_id,
        franchise_id: sample.franchise_id,
        company_name: sample.company_name,
        zone_id: sample.zone_id || zoneLocalStorageId(),
        lab_name: sample.lab_name,
        sample_type_obj: investigation.sample_type_obj,
        urgent: investigation.urgent,
        investigation_id: investigation.investigation_id,
        delivery_time: investigation.delivery_time,
        discount_by: investigation.discount_by,
        investigation_name: investigation.investigation_name,
        container_colour_code: investigation.container_colour_code,
        lab_department_name: investigation.lab_department_name,
        discount: investigation.discount,
        ifDefault: true,
        remarks: "",
      })),
    );
  }, [isSampleCollectionRowData]);

  useEffect(() => {
    if (isSampleCollectionRowData) setorgtemp(mergedArray);
  }, [isSampleCollectionRowData, mergedArray]);

  const processedData = useMemo(() => {
    const seen = new Set();
    return (bussinessReportData?.data?.data || []).map((row) => {
      const key = `${row.patient_name}-${row.appointment_id}`;
      if (seen.has(key)) {
        return {
          ...row,
          patient_name_display: "",
          age_gender_display: "",
          company_name_display: "",
          refer_doctor_name_display: "",
        };
      }
      seen.add(key);
      const ageGender = row.patient_age
        ? `${row.patient_age.year}Y ${row.patient_age.month}M ${row.patient_age.days}D | ${row.gender}`
        : "-";
      return {
        ...row,
        patient_name_display: row.patient_name,
        age_gender_display: ageGender,
        refer_doctor_name_display: row.refer_doctor_name || "",
        company_name_display: row.franchise_code || "",
      };
    });
  }, [bussinessReportData]);

  const columns = useMemo(
    () =>
      DOCUMENT_COLUMNS_DATA({
        openObservationDetails,
        downloadInvestigationDocument,
        openPatientDetails,
        openObservationValue,
        openSampleCollection,
        filters,
        fIsSuperFranchise,
        fIsFranchiseEmployee,
        subFranchise,
        toggleSelectAll,
        selectedRows,
        editableRows,
        setEditableRows,
        toggleSelectRow,
        data: bussinessReportData?.data?.data || [],
        setCurrentRowData,
        openDownloadPdf,
        openDownloadPdfSuccessFully,
        directDownloadPdfSuccessFully,
        openHtml,
        handleUploadAttachmentWithObservation,
        setIsOpenApproved,
        processedData,
      }),
    [
      filters,
      openObservationDetails,
      downloadInvestigationDocument,
      openPatientDetails,
      openObservationValue,
      openSampleCollection,
      fIsSuperFranchise,
      fIsFranchiseEmployee,
      subFranchise,
      toggleSelectAll,
      selectedRows,
      editableRows,
      toggleSelectRow,
      bussinessReportData,
      openDownloadPdf,
      openDownloadPdfSuccessFully,
      directDownloadPdfSuccessFully,
      openHtml,
      handleUploadAttachmentWithObservation,
      setIsOpenApproved,
      processedData,
    ],
  );

  const add_observation_columns = useMemo(
    () => ADD_OBSERVATION_COLUMN_DATA(),
    [currentRowData],
  );

  const sample_collection_column = useMemo(
    () =>
      COLUMN_DATA({
        temp,
        state,
        setState,
        handleViewModal,
        setTempone,
        orgtemp,
        setorgtemp,
      }),
    [state, temp, handleViewModal, setTempone, orgtemp],
  );

  const onSuccessSampleCollection = useCallback(() => {
    showAlert("Successfully");
    setIsOpenSampleCollection(false);
    refetchSampleCollection();
    refetchByIds(pendingIdsRef.current);
    pendingIdsRef.current = [];
  }, [refetchSampleCollection, refetchByIds]);

  const onErrorSampleCollection = useCallback((error) => {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong!";
    const errorDetail = error?.response?.data?.detail;
    showAlert(errorMessage, "danger", errorDetail);
  }, []);

  const { mutate: addSampleRejectionReasonMutate, isLoading: isLoadingAdd } =
    useMutation({
      mutationFn: createSampleCollectRejectionReason,
      onSuccess: onSuccessSampleCollection,
      onError: onErrorSampleCollection,
    });

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      setIsButtonLoading(true);

      if (selectedRejection) {
        if (orgtemp?.length > 0) {
          const formattedData = {
            samples: orgtemp
              .filter(
                (inv) => inv.ifDefault === undefined || inv.ifDefault === true,
              )
              .map((inv) => ({
                appointment_id: inv.appointment_id,
                investigation_id: inv.investigation_id,
                color_code: inv.container_colour_code,
                sample_type_id: inv?.sample_type_obj[0]?.sample_type_id,
                barcode_no: inv.barcode_no,
                remark: inv.remarks,
                status: "REJECTED",
                rejection_reason_id: selectedRejection.value,
                created_by: auth?.user?.employee_code_id,
              })),
          };
          addSampleRejectionReasonMutate(formattedData);
        }
      } else {
        setRequiredFeild(true);
      }
      setIsButtonLoading(false);
    },
    [selectedRejection, orgtemp, addSampleRejectionReasonMutate],
  );

  const handleSubmitCollect = useCallback(
    (e, val) => {
      e.preventDefault();
      setIsButtonLoading(true);
      setRequiredFeild(false);

      if (orgtemp?.length > 0) {
        const filteredSamples = orgtemp.filter((inv) => inv.ifDefault === true);

        pendingIdsRef.current = filteredSamples.map((inv) => ({
          appointment_id: inv.appointment_id,
          investigation_id: inv.investigation_id,
        }));

        const formattedData = {
          samples: filteredSamples.map((inv) => ({
            appointment_id: inv.appointment_id,
            investigation_id: inv.investigation_id,
            color_code: inv.container_colour_code,
            sample_type_id:
              Array.isArray(inv.sample_type_obj) &&
              inv.sample_type_obj.length > 0
                ? inv.sample_type_obj[0].sample_type_id
                : null,
            barcode_no: inv?.barcode_no,
            remark: inv.remarks,
            status: val,
            created_by: auth?.user?.employee_code_id,
            is_checked: inv.is_checked,
            company_id: companyLocalStorageId(),
          })),
          company_id: companyLocalStorageId(),
        };

        addSampleRejectionReasonMutate(formattedData);
        setIsOpenSampleCollection(false);
        setIsButtonLoading(false);
      }
    },
    [orgtemp, addSampleRejectionReasonMutate],
  );

  useEffect(() => {
    dispatch(getPackageList());
    dispatch(getInvestigationList());
    dispatch(getFranchiseTypesList());
    dispatch(getDoctorList());
    dispatch(getZoneList());
    dispatch(getDepartmentList());
    dispatch(getStatusList());
    dispatch(getFranchiseList());
    dispatch(getLabDepartmentList());
  }, []);

  const onCloseApprovedModal = (close, ids = []) => {
    setIsOpenApproved(false);
    setExpandedRowId(null);
    refetchByIds(ids);
    setTotalPatients(
      bussinessReportData?.data?.additional_data?.total_patient_count,
    );
    setTotalTests(
      bussinessReportData?.data?.additional_data?.investigation_count,
    );
  };

  const handleBadgeClick = (badge) => {
    const appStatusValue = badge.value ?? "";
    Object.keys(searchValue).forEach((key) => {
      if (key !== "from_date" || key !== "to_date")
        updateFilter(key, searchValue[key]);
    });
    updateFilter("app_status", appStatusValue);
    handleInputChange("app_status", appStatusValue);
  };

  if (isFetching) return <Loader isLoading={isFetching} />;

  return (
    <div className="container-fluid mb-3">
      <div className="box mb-6">
        <div className="boxHeader">
          <h1>Result Entry</h1>
          <DownloadButton />
        </div>
        <div
          className="d-flex boxHeader justify-content-center gap-2 fw-bold"
          style={{ color: "rgb(13, 110, 253)" }}
        >
          <div>Total Patient: {totalPatients}</div>
          <div>Total Tests: {totalTests}</div>
        </div>
        <CommonFilter
          searchValue={searchValue}
          handleInputChange={handleInputChange}
          handleSearch={handleSearch}
          handleCheckboxChange={handleCheckboxChange}
          options={options}
          selectedZone={selectedZone}
          setSelectedZone={setSelectedZone}
          investigation_list={investigation_list}
          package_list={package_list}
          franchise_list={franchise_list}
          lab_department_list={lab_department_list}
        />
      </div>

      <div>
        {[
          { label: "ALL", color: "#f78f8f" },
          { label: "Collected", value: "COLLECTED", color: "#BFD7EA" },
          { label: "Pending", value: "PENDING", color: "#b6dffa" },
          { label: "Sample Rejected", value: "REJECTED", color: "#7AA3CC" },
          { label: "Result Not Done", value: "RESULT_NOT_DONE", color: "#fff" },
          { label: "Mac Data", value: "MAC_DATA", color: "#E2680A" },
          { label: "ReRun", value: "RERUN", color: "#F781D8" },
          { label: "InComplete", value: "INCOMPLETE", color: "#A9A9A9" },
          { label: "Result Done", value: "RESULT_DONE", color: "pink" },
          { label: "Approved", value: "APPROVED", color: "#90EE90" },
          { label: "Not Approved", value: "NOT_APPROVED", color: "#8c98f5" },
          { label: "Report Issued", value: "REPORT_ISSUED", color: "#00FFFF" },
          { label: "Hold", value: "HOLD", color: "#DAA520" },
          { label: "Received", value: "RECEIVED", color: "#fcaf95" },
          { label: "Dispatched", value: "DISPATCHED", color: "#44A3AA" },
          {
            label: "Lab Not Received",
            value: "LAB_NOT_RECEIVED",
            color: "#FFCC99",
          },
        ].map((badge) => (
          <span
            key={badge.label}
            className="badge1"
            style={{
              background: badge.color,
              cursor: "pointer",
              marginTop: "10px",
            }}
            onClick={() => handleBadgeClick(badge)}
          >
            {badge.label}
          </span>
        ))}
      </div>

      <div className="heading-form mt-3 d-flex justify-content-between align-items-center">
        <span>Search Result</span>
        {selectedRows?.length !== 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px",
              padding: "10px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="form-select form-select-sm"
                style={{ width: "150px" }}
              >
                <option value="">Select Status</option>
                <option value="APPROVED">APPROVED</option>
                <option value="NOT_APPROVED">NOT_APPROVED</option>
              </select>
            </div>
            <div>
              <button
                className="btn btn-outline-primary right btn-sm"
                onClick={() => handleSaveStatus(selectedRowsData)}
              >
                Save
              </button>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <input
                type="checkbox"
                id="checkbox2"
                checked={withFooterChecked}
                onChange={handleFooterChange}
              />
              <label htmlFor="withfooter">with header and footer</label>
            </div>
            <div>
              <button
                className="btn btn-outline-primary right btn-sm"
                onClick={() => downloadWithButton(selectedRowsData)}
              >
                Generate PDF
              </button>
            </div>
          </div>
        ) : (
          currentRowData && (
            <button
              onClick={() => setCurrentRowData(null)}
              className="btn btn-outline-primary right btn-sm"
            >
              Go Back
            </button>
          )
        )}
      </div>

      <Modal
        type="modal-xl"
        show={isOpenObservationValue}
        onHide={() => onObservationValueClose(true)}
        modalName={MODALS.ADD_OBSERVATION_RESULT_ENTRY_MODAL}
        title={
          <span style={{ fontSize: "15px" }}>Patient LAB Result Entry</span>
        }
        body={
          <AddObservationValue
            handleDocuments={handleDocuments}
            rowData={rowDataForObservation}
            onClose={onObservationValueClose}
            documentInfo={documentInfo}
            refetchBussinessReport={refetchBussinessReport}
            isOpenObservationValue={isOpenObservationValue}
          />
        }
      />

      <Modal
        type="modal-xl"
        show={isOpenSampleCollection}
        onHide={() => setIsOpenSampleCollection(false)}
        modalName={MODALS.ADD_SAMPLE_MODAL}
        title={
          <div>
            {"Collect Sample"}
            {(() => {
              const statusColorMap = {
                PENDING: { color: "orange", label: "Pending" },
                REJECTED: { color: "red", label: "Rejected" },
                COLLECTED: { color: "green", label: "Collected" },
                RECEIVED: { color: "blue", label: "Received" },
                "COLLECT & RECEVIED": {
                  color: "purple",
                  label: "Collect & Recevied",
                },
              };
              return Object.entries(statusColorMap).map(
                ([key, { color, label }]) => (
                  <span
                    key={key}
                    style={{
                      padding: "5px 10px",
                      borderRadius: "5px",
                      backgroundColor: color,
                      color: "white",
                      marginLeft: "10px",
                      fontSize: "10px",
                    }}
                  >
                    {label}
                  </span>
                ),
              );
            })()}
            <span style={{ marginLeft: "85px", fontSize: "16px" }}>
              {`Patient Name: ${isSampleCollectionRowData?.[0]?.patient_name}`}
            </span>
          </div>
        }
        body={
          <form>
            <Table
              data={mergedArray || []}
              isLoading={isLoading}
              tableColumns={sample_collection_column}
              showPagination={false}
            />
            <div className="mt-2">
              <RejectionReasonDropDown
                onChange={handleSelectedRejection}
                required={requiredFeild}
              />
            </div>
            <div className="d-flex justify-content-between">
              <button
                className="btn btn-primary mt-4"
                onClick={(e) => handleSubmit(e)}
                disabled={isButtonLoading || isLoading}
              >
                Reject
              </button>
              <button
                className="btn btn-primary mt-4"
                onClick={(e) => handleSubmitCollect(e, "COLLECTED")}
                disabled={isButtonLoading || isLoading}
              >
                Collect
              </button>
              <button
                className="btn btn-primary mt-4"
                onClick={(e) => handleSubmitCollect(e, "RECEIVED")}
                disabled={isButtonLoading || isLoading}
              >
                Received
              </button>
              <button
                className="btn btn-primary mt-4"
                onClick={(e) => handleSubmitCollect(e, "COLLECT & RECEVIED")}
                disabled={isButtonLoading || isLoading}
              >
                Collect & Received
              </button>
            </div>
          </form>
        }
      />

      <Modal
        type="modal-xl"
        show={viewModal}
        onHide={() => setViewModal(false)}
        modalName={MODALS.ADD_MODAL}
        title={"Sample Information"}
        body={
          // <SampleInformation
          //   rowData={isSampleCollectionRowData}
          //   onClose={onClose}
          // />
          <ObservationInformation rowData={viewObservationData?.data} />
        }
        footer={
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => setViewModal(false)}
          >
            Close
          </button>
        }
      />

      <Modal
        type="modal-xl"
        show={isObservationOpenDetails}
        onHide={() => handleCloseObservationDetails(true)}
        modalName={MODALS.ADD_OBSERVATION_RESULT_ENTRY_MODAL}
        title={<div>{"Observation Details"}</div>}
        body={<ObservationInformation rowData={viewObservationData?.data} />}
        footer={
          <button
            type="submit"
            className="btn btn-primary mt-4"
            onClick={() => handleCloseObservationDetails(true)}
          >
            Close
          </button>
        }
      />

      <Modal
        type="modal-lg"
        show={documentModal}
        onHide={() => setDocumentModal(false)}
        modalName={MODALS.ADD_MODAL}
        title={"Upload File"}
        body={
          <UploadDocument
            rowData={rowDataForObservation}
            onClose={onClose}
            setdocumentInfo={setdocumentInfo}
            setDocumentModal={setDocumentModal}
            setIsOpenObservationValue={setIsOpenObservationValue}
            openedFrom={openedFrom}
          />
        }
      />

      {!currentRowData ? (
        <Table
          data={bussinessReportData?.data?.data || []}
          isLoading={isFetching}
          tableColumns={columns}
          currentPage={currentPage}
          totalPages={totalPages}
          itemPerPage={itemPerPage}
          disablePrev={disablePrev}
          disableNext={disableNext}
          totalRecords={5}
          loadNextPage={loadNextPage}
          loadPreviousPage={loadPreviousPage}
          showPagination={false}
          renderExpandedRow={
            isOpenApproved
              ? (rowData) => (
                  <div
                    style={{
                      textAlign: "left",
                      width: "100%",
                      padding: "10px 0",
                    }}
                  >
                    <ApprovedModalInsideRow
                      handleDocuments={handleDocuments}
                      rowData={rowData}
                      onClose={onCloseApprovedModal}
                      documentInfo={documentInfo}
                      refetchBussinessReport={refetchBussinessReport}
                      isOpenObservationValue={true}
                      editObservationValue={editObservationValue}
                    />
                  </div>
                )
              : null
          }
          expandedRowId={expandedRowId}
          setExpandedRowId={setExpandedRowId}
        />
      ) : (
        <Table
          data={listPayment?.data?.observations || []}
          isLoading={isLoadingPayment}
          tableColumns={add_observation_columns}
          currentPage={currentPage}
          totalPages={totalPages}
          itemPerPage={itemPerPage}
          disablePrev={disablePrev}
          disableNext={disableNext}
          totalRecords={5}
          loadNextPage={loadNextPage}
          loadPreviousPage={loadPreviousPage}
        />
      )}
    </div>
  );
};

export default PannelWiseBusinessReport;
